import ENV from "../../env";
import { startMicrosoftSignIn } from "../../helpers/microsoftSignIn";
import ErrorContent from "../ErrorContent/ErrorContent";
import { useAuthTranslation } from "../../services/culture/auth.translations";
import { useCommonTranslation } from "../../services/culture/common.translations";

export const MigrateComponent = () => {
  const { t: tAuth } = useAuthTranslation();
  const { t: tCommon } = useCommonTranslation();
  const params = new URLSearchParams(window.location.search);
  const clientId = params.get("client_id") || "";
  const redirectUri = params.get("redirect_uri") || "";
  const responseType = params.get("response_type") || "code";
  const scope = params.get("scope") || "openid";
  const state = params.get("state") || "";
  const nonce = params.get("nonce") || "";

  return (
    <ErrorContent
      title={tAuth("migrate.microsoftAuthRequired")}
      message={`${tAuth("migrate.microsoftAuthRequiredDescription")}\n\n${tAuth("migrate.microsoftAuthRequiredPrompt")}`}
      actions={[
        {
          label: tCommon("common.yes"),
          color: "green",
          onClick: () => {
            const signinParams = new URLSearchParams({
              migrating: "true",
              client_id: clientId,
              redirect_uri: redirectUri,
              response_type: responseType,
              scopes: scope,
              state,
              nonce,
            });
            startMicrosoftSignIn(`${ENV.API_SERVER}/microsoft/signin?${signinParams.toString()}`);
          },
        },
        {
          label: tCommon("common.no"),
          color: "red",
          onClick: async () => {
            window.location.replace(`${ENV.API_SERVER}/logout`);
          },
        },
      ]}
    />
  );
};
